window.Popup = {
    openPopup: function ({key, props}) {
        window.sellsyapp.config.globalProperties.$store.state.popupPanel[key].props = props
        window.sellsyapp.config.globalProperties.$store.state.popupPanel[key].display = true
    },
    closePopup: function (key) {
        window.sellsyapp.config.globalProperties.$store.state.popupPanel[key].display = false
    }
}
